import videojs from 'video.js'
const Component = videojs.getComponent('Component')

const TextTrackMenuItem = videojs.getComponent('TextTrackMenuItem')
const OffTextTrackMenuItem = videojs.getComponent('OffTextTrackMenuItem')
const CaptionSettingsMenuItem = videojs.getComponent('CaptionSettingsMenuItem')

class NFBCaption extends Component {

  constructor(player) {
    super(player)

    this.nfbCaptionKinds = ['captions', 'subtitles']
    this.captionItems = []

    this.buildCaptionMenu()
    
    // When source change is triggered by DV button
    // we want to dispose all quality items

    player.one('sourcechanged', () => {
      this.dispose()
    })
  }

  dispose() {
    this.subtitleContainer?.remove()
    this.captionItems.forEach((i) => {
      i.dispose()
    })
  }

  buildCaptionMenu() {
    // Captions OFF menu item
    this.captionItems.push(new OffTextTrackMenuItem(this.player(), {
      kinds: this.nfbCaptionKinds,
      label: 'captions off'
    }))

    // Tracks options
    this.player().textTracks().tracks_.forEach((track) => {
      if (this.nfbCaptionKinds.indexOf(track.kind) > -1) {
        const item = new TextTrackMenuItem(this.player(), {
          track,
          kinds: this.nfbCaptionKinds,
          kind: track.kind,
          // MenuItem is selectable
          selectable: true,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: false
        })
        this.captionItems.push(item)
      }
    })

    // captions settings option
    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) &&
      this.player().getChild('textTrackSettings')) {
      this.captionItems.push(new CaptionSettingsMenuItem(this.player(), {
        kind: 'captions',
        label: 'captions settings',
        mode: 'disabled'
      }))
    }

    // We add the settings panel button to the subsCapsButton in order for the focus selector
    // to move to the next button once the CaptionSettings Dialog is closed

    this.player().controlBar.subsCapsButton = this.player().el().querySelector('[data-ui-el="settings-panel-button"]')
    this.player().controlBar.subsCapsButton.menu = this.captionItems

    // we trigger this event to manage captions custom events and persists options
    this.player().trigger('nfbcaptionready')

    this.subtitleContainer = document.createElement('div')
    this.subtitleContainer.classList.add('nfb-settings-panel__items-container')
    this.subtitleContainer.setAttribute('data-ui-el', 'settings-panel-caption')
    this.subtitleContainer.setAttribute('data-cy', 'settings-panel-caption')
    this.subtitleContainer.innerHTML = `<span class="nfb-settings-panel__item-title">${this.player().localize('Subtitles')}</span>`
    this.player().el().querySelector('[data-ui-el="settings-panel"]').prepend(this.subtitleContainer)

    this.captionItems.forEach((captionItem) => {
      if (captionItem.name_ === 'CaptionSettingsMenuItem') {
        captionItem.el().classList.add('nfb-caption__settings-panel-button')
      }
      captionItem.el().classList.add('nfb-settings-panel__item')
      captionItem.el().setAttribute('tabindex', '0')
      this.subtitleContainer.appendChild(captionItem.el())
    })
  }
}

videojs.registerComponent('NFBCaption', NFBCaption);
